import CnFormPrototypeView from './cn-form/prototypeView';
import CnPagePrototypeView from './cn-page/prototypeView';
import CnFilterPrototypeView from './cn-filter/prototypeView';
import CnTablePrototypeView from './cn-table/prototypeView';
import CnFormDialogPrototypeView from './cn-form-dialog/prototypeView';
import CnStepPrototypeView from './cn-step/prototypeView';
import CnNavBarPrototypeView from './cn-nav-bar/prototypeView';
import CnDetailInfoPrototypeView from './cn-detail-info/prototypeView';
import CnMessagePrototypeView from './cn-message/prototypeView';
import CnTabPrototypeView from './cn-tab/prototypeView';
import CnCardPrototypeView from './cn-card/prototypeView';
import CnListPrototypeView from './cn-list/prototypeView';
import CnResultPrototypeView from './cn-result/prototypeView';
import CnEntryPointsPrototypeView from './cn-entry-points/prototypeView';
const bundle = [
    CnFormPrototypeView,
    CnPagePrototypeView,
    CnFilterPrototypeView,
    CnTablePrototypeView,
    CnFormDialogPrototypeView,
    CnStepPrototypeView,
    CnNavBarPrototypeView,
    CnDetailInfoPrototypeView,
    CnTabPrototypeView,
    CnMessagePrototypeView,
    CnCardPrototypeView,
    CnListPrototypeView,
    CnResultPrototypeView,
    CnEntryPointsPrototypeView,
];
export default bundle;
